import { z } from 'zod';

export const Fee_itemsScalarFieldEnumSchema = z.enum(['id','amount','fee_type','permits_type_id','permits_fee_id','created_at','updated_at','standard_conditional_field_key','conditional_field_id','data','order']);

export default Fee_itemsScalarFieldEnumSchema;
